/**
 * Finds a matching SubFormProvider from the widget's root parameters based on type.
 *
 * @param {WidgetProps<any, any>} props - The widget props containing root parameters.
 * @param {string} type - The type of the subform to find.
 * @returns {SubFormProvider | undefined} The matching subform provider, if found.
 */
export function findSubFormProvider(props, type) {
    if (Array.isArray(props.rootParams.subFormProviders)) {
        return props.rootParams.subFormProviders.find((p) => p.type === type && typeof p.getSubForm === 'function');
    }
    else {
        return undefined;
    }
}
